'use strict';

angular.module('app.components').component('segmentoSelecionado', {
    bindings: {
        parametros: '='
    },
    transclude: true,
    controllerAs: '$ctrl',
    controller: segmentoSelecionadoCtrl,
    template: require('./segmento.html')
});

segmentoSelecionadoCtrl.$inject = ['$sessionStorage', 'segmentosApi', 'notificacao'];
function segmentoSelecionadoCtrl($sessionStorage, segmentosApi, notificacao) {
    var $ctrl = this;

    $ctrl.exibir = { segmento: null, credencial: null };

    $ctrl.$onInit = function(){
        if (_.has($ctrl.parametros, '$$state')) {
            $ctrl.parametros.then(function (chamado) {
                obterDadosChamado({
                    grupoDeSuporteId: chamado.grupoDeSuporteSegmento.grupoDeSuporte.grupoDeSuporteId,
                    grupoDeSuporteSegmentoId: chamado.grupoDeSuporteSegmento.grupoDeSuporteSegmentoId
                });
            });
        } else {
            obterDadosChamado($ctrl.parametros);
        }
    }

    function obterDadosChamado(parametros) {
        segmentosApi.lerDadosChamado(parametros, function (segmentoSelecionado) {
            $ctrl.exibir = {
                segmento: segmentoSelecionado,
                credencial: $sessionStorage.credencial.data
            };
        }, function error(errorResponse) {
            notificacao.erroResponse(errorResponse);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/segmento-selecionado/index.js
// module id = 319
// module chunks = 1